<template>
  <div class="py-5 container-fluid">
    <div id="topinfo">
      <div class="row mt-4 justify-content-center">
        <div class="col-12">
          <div class="mx-auto mx-auto col-xl-9 col-lg-10 col-md-11 col-sm-12 text-start mt-3 mb-0">
            <button
              class="btn btn-outline-secondary btn-sm px-3 mt-1 mb-3"
              @click="$router.push({ name: 'LineVisits', params: { lineId: lineId } })"
            >
              <font-awesome-icon :icon="['fas', 'arrow-rotate-left']" />
              Go back to visits
            </button>
          </div>
          <div
            class="mx-auto col-xl-9 col-lg-10 col-md-11 col-sm-12 d-flex mb-2 flex-column card card-body blur shadow-blur"
          >
            <div class="card-header mb-0 text-center">
              <h3 class="font-weight-bolder text-success text-gradient">Guns Equalization</h3>
              <h5
                v-if="line.name"
                class="mb-0"
              >
                for Line <i>{{ line.name }}</i>
              </h5>
            </div>
          </div>
          <div
            class="mx-auto col-xl-9 col-lg-10 col-md-11 col-sm-12 d-flex flex-column card card-body blur shadow-blur"
          >
            <div
              class="card-body mb-0 pb-3"
              style="padding-top: 0.5rem"
            >
              <div class="row">
                <div class="row mb-3">
                  <h5>Powder Amount Parameters</h5>
                  <div class="row mb-3">
                    <div class="col-3">
                      <label> Min </label>
                      <div v-if="!visitFinalized">
                        <input
                          v-model.lazy="minPowderAmountSetting"
                          type="number"
                          class="form-control my-2"
                          placeholder="MIN"
                          min="0"
                          @keydown="numericPositiveOnly"
                          @change="
                            PowderAmountSettingAlertCheck();
                            saveFormProgress();
                            getPowderAmountCalibrationStatistic();
                          "
                        />
                      </div>
                      <div v-else>
                        <p class="px-1">{{ minPowderAmountSetting }}</p>
                      </div>
                    </div>
                    <div class="col-3">
                      <label> Max </label>
                      <div v-if="!visitFinalized">
                        <input
                          v-model.lazy="maxPowderAmountSetting"
                          type="number"
                          class="form-control my-2"
                          placeholder="MAX"
                          :min="minPowderAmountSetting !== null ? minPowderAmountSetting : 0"
                          @keydown="numericPositiveOnly"
                          @change="
                            PowderAmountSettingAlertCheck();
                            saveFormProgress();
                          "
                        />
                      </div>
                      <div v-else>
                        <p class="px-1">{{ maxPowderAmountSetting }}</p>
                      </div>
                    </div>
                    <div class="col-3">
                      <label> Time Interval [s]</label>
                      <div v-if="!visitFinalized">
                        <input
                          v-model="timeInterval"
                          type="number"
                          min="15"
                          class="form-control my-2"
                          placeholder="TIME INTERVAL"
                          @keydown="numericPositiveOnly"
                          @change="saveFormProgress"
                        />
                      </div>
                      <div v-else>
                        <p class="px-1">{{ timeInterval }}s</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <h5 class="mt-2">Line Layout</h5>
                <div class="d-flex justify-content-center">
                  <canvas
                    id="lineLayoutCanvas"
                    class="col-12 mt-0 mb-4"
                    width="700"
                    height="300"
                    :style="`max-width: 1280px; ${line.id !== null ? '' : 'display: none;'}`"
                  >
                  </canvas>
                </div>
              </div>
              <div class="row">
                <h5 class="text-start">Powder Output Measurements</h5>
                <div style="overflow-x: auto">
                  <div class="table-responsive">
                    <table
                      class="table table-sm text-start"
                      style="border-width: 0 !important"
                    >
                      <thead>
                        <tr>
                          <th class="text-center">Gun Name</th>
                          <th>Empty bag weight</th>
                          <th
                            v-for="index in maxPairs"
                            :key="'header-' + index"
                          >
                            Setting {{ index }} Weight {{ index }}
                          </th>
                          <th v-if="!visitFinalized">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(gun, gunIndex) in powderoutput_measurements"
                          :key="gunIndex"
                        >
                          <td class="text-center">
                            <div>
                              <p>{{ gunNamesExist(gun_names) ? gun_names[gunIndex] : gunIndex + 1 }}</p>
                            </div>
                          </td>
                          <td>
                            <div v-if="!visitFinalized">
                              <input
                                v-model.lazy="gun.empty_bag_weight"
                                type="number"
                                class="form-control form-control-sm"
                                min="0"
                                style="max-width: 90px"
                                @keydown="numericPositiveOnly"
                                @change="
                                  powderoutput_measurements = autoFillInputColumn(
                                    powderoutput_measurements,
                                    gunIndex,
                                    'empty_bag_weight',
                                  );
                                  saveFormProgress();
                                "
                              />
                            </div>
                            <div v-else>
                              <p class="px-1">
                                {{ gun.empty_bag_weight }}
                                {{ $store.state.units_system[$store.state.user_data.unit_system].grams }}
                              </p>
                            </div>
                          </td>
                          <td
                            v-for="index in maxPairs"
                            :key="'pair-' + gunIndex + '-' + index"
                          >
                            <div
                              v-if="gun.gun_measurements[index - 1]"
                              class="d-flex"
                            >
                              <div
                                v-if="!visitFinalized"
                                class="d-flex"
                              >
                                <input
                                  v-model="gun.gun_measurements[index - 1].setting"
                                  type="number"
                                  :class="`form-control ${
                                    gun.gun_measurements[index - 1].setting != '' &&
                                    (gun.gun_measurements[index - 1].setting < minPowderAmountSetting ||
                                      gun.gun_measurements[index - 1].setting > maxPowderAmountSetting)
                                      ? 'is-invalid'
                                      : ''
                                  } form-control-sm me-1`"
                                  placeholder="Setting"
                                  min="0"
                                  style="max-width: 90px"
                                  @keydown="numericPositiveOnly"
                                  @change="
                                    autoFillPowderOutputMeasurements(gunIndex, index - 1);
                                    saveFormProgress();
                                  "
                                  @blur="PowderAmountSettingInputRangeCheck($event.target.value, gunIndex)"
                                />
                                <input
                                  v-model="gun.gun_measurements[index - 1].weight"
                                  type="number"
                                  class="form-control form-control-sm me-1"
                                  placeholder="Weight"
                                  min="0"
                                  style="max-width: 90px"
                                  @keydown="numericPositiveOnly"
                                  @blur="PowderAmountWeightCheck($event.target.value, gunIndex)"
                                  @change="saveFormProgress"
                                />
                              </div>
                              <div v-else>
                                <p
                                  class="px-1"
                                  style="margin: 0; padding: 0; display: inline"
                                >
                                  {{ gun.gun_measurements[index - 1].setting }}
                                </p>
                                <p
                                  class="px-6"
                                  style="margin: 0; padding: 0; display: inline"
                                >
                                  {{ gun.gun_measurements[index - 1].weight }}
                                  {{ $store.state.units_system[$store.state.user_data.unit_system].grams }}
                                </p>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div
                              v-if="!visitFinalized"
                              class="d-flex"
                            >
                              <button
                                class="btn btn-success"
                                @click="addPair(gunIndex)"
                              >
                                Add
                              </button>
                              <div class="col-1"></div>
                              <button
                                v-if="gun.gun_measurements.length > 2"
                                class="btn btn-danger"
                                @click="deletePair(gunIndex)"
                              >
                                Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                        <td :colspan="maxPairs + 2">
                          <div
                            v-if="!visitFinalized"
                            class="text-center mt-0 mb-0"
                          >
                            <button
                              class="btn btn-primary"
                              @click="showGunsEqualizationGraph"
                            >
                              Show Powder Output Chart
                            </button>
                            <button
                              class="btn btn-info ms-4"
                              @click="fillWithLatestMeasurements()"
                            >
                              Fill With Latest Measurements
                            </button>
                          </div>
                        </td>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div
                v-if="!emptyPowderAmountLimits && !emptyPowderOutputMeasurements && showPowderThroughputData"
                class="row"
              >
                <div class="col-lg-7">
                  <h5 class="">Powder Output Chart</h5>
                  <guns-equalization-chart />
                </div>
                <div class="col-lg-5">
                  <div class="card text-bolder mt-6 text-center">
                    Statistics of current throughput per gun:
                    <p class="mt-4">
                      Min throughput: {{ original_powder_throughput_statistics.min_value }}
                      {{ $store.state.units_system[$store.state.user_data.unit_system].powder_output }}
                    </p>
                    <p>
                      Max throughput: {{ original_powder_throughput_statistics.max_value }}
                      {{ $store.state.units_system[$store.state.user_data.unit_system].powder_output }}
                    </p>
                    <p>
                      Max throughput difference: {{ original_powder_throughput_statistics.diff_value }}
                      {{ $store.state.units_system[$store.state.user_data.unit_system].powder_output }}
                    </p>
                    <p>
                      Throughput std dev: {{ original_powder_throughput_statistics.std_value }}
                      {{ $store.state.units_system[$store.state.user_data.unit_system].powder_output }}
                    </p>
                  </div>
                </div>
              </div>
              <div v-if="emptyBenchmarkPowderAmounts">
                To see equalized Powder Amount settings, first provide Powder Amount settings for each gun at Benchmark
                Stage.
              </div>
              <div v-if="!emptyBenchmarkPowderAmounts && emptyPowderAmountLimits">
                To see equalized Powder Amount settings, first provide the Min and Max Powder Amount settings at the top
                of the page.
              </div>
              <div v-if="!emptyBenchmarkPowderAmounts && !emptyPowderAmountLimits && emptyPowderOutputMeasurements">
                To see equalized Powder Amount settings, first provide Powder Output Measurements above.
              </div>
              <div
                v-if="
                  !emptyBenchmarkPowderAmounts &&
                  !emptyPowderAmountLimits &&
                  !emptyPowderOutputMeasurements &&
                  showPowderThroughputData
                "
              >
                <gun-throughput
                  title="Guns Equalization"
                  :gun-throughput="gunExpectedOutput"
                  :mean-thickness="meanThickness"
                  :line="line"
                  :powder-amount-parameters="powder_amount_parameters"
                  :is-compliant-with-target-throughput-per-gun="is_compliant_with_target_throughput_per_gun"
                  :diagnosis-values-per-gun="diagnosis_values_per_gun"
                  :min-powder-amount-setting="minPowderAmountSetting"
                  :max-powder-amount-setting="maxPowderAmountSetting"
                />
              </div>
              <div class="row mt-4">
                <div class="col-lg-6">
                  <ThicknessMeasurementsTable
                    v-model="thickness_measurements"
                    :is-editable="!visitFinalized"
                    :unit-thickness="$store.state.units_system[$store.state.user_data.unit_system].thickness_blueprint"
                    @update:modelValue="saveFormProgress()"
                  />
                  <div
                    v-if="!visitFinalized"
                    class="text-center mt-0 mb-0"
                  >
                    <button
                      class="btn btn-primary"
                      @click="showThicknessGraph()"
                    >
                      Show thickness distribution chart
                    </button>
                  </div>
                </div>
                <div class="col-lg-6">
                  <gaussian-chart
                    title="Thickness Distribution Chart"
                    chart-name="gaussianGunsEqualizationChart"
                  />
                  <thickness-measurement-statistic
                    :benchmark-thickness-measurements="benchmark_stage_data.thickness_measurements"
                    :guns-equalization-thickness-measurements="statistics_thickness_measurements"
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="
              !emptyBenchmarkPowderAmounts &&
              !emptyPowderAmountLimits &&
              !emptyPowderOutputMeasurements &&
              !emptyThicknessMeasurements
            "
            class="mx-auto col-xl-9 col-lg-10 col-md-11 col-sm-12 d-flex button-row mt-3"
          >
            <soft-button
              v-if="visitFinalized"
              type="button"
              color="secondary"
              variant="gradient"
              :full-width="true"
              class="me-2 ms-auto"
            >
              VISIT COMPLETED
            </soft-button>
            <soft-button
              type="button"
              color="success"
              variant="gradient"
              class="ms-auto mb-0 me-2"
              style="min-width: 270px; max-width: 300px"
              @click="$router.push({ name: 'SprayPatternStage', params: { lineId: lineId, visitId: visitId } })"
            >
              Continue to Spray Pattern &nbsp;
              <font-awesome-icon
                :icon="['fas', 'circle-chevron-right']"
                size="lg"
              />
            </soft-button>
          </div>
          <stepper-line-visit
            :line-id="lineId"
            :visit="visit"
            :finalized-at-stage="visit.finalized_at_stage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import setTooltip from "@/assets/js/tooltip.js";
import axios from "axios";
import eventBus from "./utils/eventBus";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { nextTick } from "vue";
import { faArrowRotateLeft, faCircleChevronRight } from "@fortawesome/free-solid-svg-icons";

import {
  calculateMu,
  calculateSigma,
  gaussian,
  generateX,
  generateXforMultipleMuSigma,
  generateY,
  generateYwithXvalues,
} from "./utils/gaussianchart";
import {
  autoFillInputColumn,
  checkLastRow,
  cleanThicknessMeasurementsArray,
  generateMeasurementList,
  getLatestPowderOutputMeasurementsByLine,
  gunNamesExist,
  isEmptyPowderOutputMeasurements,
  markVisitAsFinalized,
  numericPositiveOnly,
  roundPowderAmountParameters,
  useGetBenchmark,
  useGetLine,
  useGetVisit,
} from "@/views/composables.js";
import GaussianChart from "./components/GaussianChart.vue";
import GunsEqualizationChart from "./components/GunsEqualizationChart.vue";
import GunThroughput from "./components/GunThroughput.vue";
import SoftButton from "../../../components/SoftButton.vue";
import StepperLineVisit from "./components/StepperLineVisit.vue";
import ThicknessMeasurementStatistic from "./components/ThicknessMeasurementStatistic.vue";
import ThicknessMeasurementsTable from "./components/ThicknessMeasurementsTable.vue";

library.add([faArrowRotateLeft, faCircleChevronRight]);

export default {
  name: "GunsEqualization",
  components: {
    StepperLineVisit,
    GaussianChart,
    GunsEqualizationChart,
    GunThroughput,
    ThicknessMeasurementStatistic,
    ThicknessMeasurementsTable,
    SoftButton,
    FontAwesomeIcon,
  },
  props: {
    lineId: {
      type: String,
      default: "",
    },
    visitId: {
      type: String,
      default: "",
    },
  },
  setup() {
    const { line, getLine } = useGetLine();
    const { visit, getVisit } = useGetVisit();
    const { benchmark_stage_data, getBenchmarkData } = useGetBenchmark();
    return { visit, getVisit, benchmark_stage_data, getBenchmarkData, line, getLine };
  },
  data() {
    this.$i18n.locale = this.$store.state.user_data.language;

    return {
      original_powder_throughput_statistics: {
        min_value: null,
        max_value: null,
        diff_value: null,
        std_value: null,
      },
      powderoutput_measurements: [
        {
          empty_bag_weight: null,
          gun_measurements: [
            {
              setting: "",
              weight: "",
            },
            {
              setting: "",
              weight: "",
            },
            {
              setting: "",
              weight: "",
            },
          ],
        },
      ],
      showPowderThroughputData: false,
      minPowderAmountSetting: null,
      maxPowderAmountSetting: null,
      min_powder_throughput: null,
      timeInterval: 60,
      thickness_measurements: [null, null, null, null, null],
      statistics_thickness_measurements: [null, null, null, null, null],
      expected_powder_per_minute: null,
      powder_amount_parameters: [],
      is_compliant_with_target_throughput_per_gun: [],
      diagnosis_values_per_gun: [],
      canvas_width: null,
      canvas_height: null,
      ctx_line_layout: null,
      line_layout_image: [],
      gun_names: [],
    };
  },
  computed: {
    gunExpectedOutput: {
      get() {
        if (this.expected_powder_per_minute == null || this.expected_powder_per_minute == "") {
          return 0;
        } else {
          return parseFloat(this.expected_powder_per_minute.toFixed(0));
        }
      },
      set(value) {
        this.expected_powder_per_minute = value;
      },
    },
    meanThickness() {
      if (
        this.benchmark_stage_data == null ||
        this.benchmark_stage_data.thickness_measurements == null ||
        !Array.isArray(this.benchmark_stage_data.thickness_measurements)
      ) {
        return 0;
      }

      const clean_thickness_measurements_array = this.cleanThicknessMeasurementsArray(
        this.benchmark_stage_data.thickness_measurements,
      );

      if (clean_thickness_measurements_array.length < 2) {
        return 0;
      }

      return this.calculateMu(clean_thickness_measurements_array);
    },
    maxPairs() {
      let maxPairs = 0;
      this.powderoutput_measurements.forEach(gun => {
        if (gun.gun_measurements.length > maxPairs) {
          maxPairs = gun.gun_measurements.length;
        }
      });
      return maxPairs;
    },
    emptyBenchmarkPowderAmounts() {
      if (this.benchmark_stage_data.gun_settings == null) {
        return true;
      }
      const powderAmountSettings = this.benchmark_stage_data.gun_settings.map(item => item.powder);
      const emptyPowderAmounts = powderAmountSettings.some(
        powder_amount_setting => powder_amount_setting == "" || powder_amount_setting == null,
      );
      return emptyPowderAmounts;
    },
    emptyPowderAmountLimits() {
      return (
        this.minPowderAmountSetting == null ||
        this.minPowderAmountSetting == "" ||
        this.maxPowderAmountSetting == null ||
        this.maxPowderAmountSetting == ""
      );
    },
    emptyPowderOutputMeasurements() {
      const empty_powder_output_measurements = this.powderoutput_measurements.some(gun =>
        gun.gun_measurements.some(pair => pair.setting == "" || pair.weight == ""),
      );
      const empty_bag_weight_measurements = this.powderoutput_measurements.some(
        gun => gun.empty_bag_weight == null || gun.empty_bag_weight == "",
      );

      return empty_powder_output_measurements || empty_bag_weight_measurements;
    },
    emptyThicknessMeasurements() {
      if (
        this.thickness_measurements == null ||
        this.thickness_measurements == undefined ||
        this.thickness_measurements == "" ||
        !Array.isArray(this.thickness_measurements)
      ) {
        return true;
      }
      return this.thickness_measurements.filter(m => m !== null && m !== "").length < 2;
    },
    visitFinalized() {
      return (
        this.visit.finalized_at_stage == "finalized_at_spraypattern" ||
        this.visit.finalized_at_stage == "finalized_at_reciprocator" ||
        this.visit.finalized_at_stage == "finalized_at_thickness_adjustment"
      );
    },
    totalLineGuns() {
      return this.line.total_pistols.reduce((a, b) => a + b, 0);
    },
    powderAmountWithinRange() {
      if (
        this.minPowderAmountSetting !== null &&
        this.minPowderAmountSetting !== "" &&
        this.maxPowderAmountSetting !== null &&
        this.maxPowderAmountSetting !== ""
      ) {
        const powderAmountSettings = this.benchmark_stage_data.gun_settings.map(item => item.powder);
        return powderAmountSettings.every(
          powder_amount_setting =>
            powder_amount_setting >= this.minPowderAmountSetting &&
            powder_amount_setting <= this.maxPowderAmountSetting,
        );
      } else {
        return true;
      }
    },
  },
  mounted() {
    var lineLayoutCanvas = document.getElementById("lineLayoutCanvas");
    this.canvas_width = lineLayoutCanvas.width;
    this.canvas_height = lineLayoutCanvas.height;
    this.ctx_line_layout = lineLayoutCanvas.getContext("2d");

    this.$store.state.isAbsolute = true;
    setTooltip();
    this.getData();
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
  },
  methods: {
    autoFillInputColumn,
    calculateMu,
    calculateSigma,
    checkLastRow,
    cleanThicknessMeasurementsArray,
    gaussian,
    generateMeasurementList,
    generateX,
    generateXforMultipleMuSigma,
    generateY,
    generateYwithXvalues,
    getLatestPowderOutputMeasurementsByLine,
    gunNamesExist,
    isEmptyPowderOutputMeasurements,
    markVisitAsFinalized,
    numericPositiveOnly,
    roundPowderAmountParameters,
    async getData() {
      await this.getVisit(this.visitId);
      await this.getLine(this.lineId);
      this.gun_names = this.line.gun_names;
      await this.getBenchmarkData(this.visitId, this.totalLineGuns);

      this.powderoutput_measurements = this.generateGuns(this.totalLineGuns);

      await this.getGunEqualizationData();

      await this.generateLineLayoutImage();
      this.fillLineLayoutCanvas();

      this.showThicknessGraph();
    },
    generateGuns(total_guns) {
      return Array.from({ length: total_guns }, () => ({
        empty_bag_weight: null,
        gun_measurements: [
          {
            setting: "",
            weight: "",
          },
          {
            setting: "",
            weight: "",
          },
          {
            setting: "",
            weight: "",
          },
        ],
      }));
    },
    async getGunsEqualizationChartDataset() {
      if (this.emptyPowderOutputMeasurements) {
        return;
      }

      let body = {
        min_powder_amount_setting: this.minPowderAmountSetting,
        max_powder_amount_setting: this.maxPowderAmountSetting,
        time_interval: this.timeInterval,
        powderoutput_measurements: this.powderoutput_measurements,
        cumulative_powderoutput_measurements: true,
      };

      let response = await axios.post("/api/v1/blueprint/gunsequalizationchart/", body);

      this.$store.state.gunsEqualizationChart = response.data.powderoutput_measurements;
      if (gunNamesExist(this.gun_names)) {
        this.$store.state.gunsEqualizationChart.datasets.forEach((dataset, index) => {
          dataset.label = "Gun " + this.gun_names[index];
        });
      }
    },
    async getPowderAmountCalibrationStatistic() {
      if (this.emptyBenchmarkPowderAmounts || this.emptyPowderOutputMeasurements) {
        return;
      }

      try {
        let body = {
          time_interval: this.timeInterval,
          measures_list: this.generateMeasurementList(this.powderoutput_measurements),
          powder_amounts: this.visit.benchmarkstage.gun_settings.map(setting => parseFloat(setting.powder)),
          cumulative_powderoutput_measurements: true,
          min_powder_amount_setting: this.minPowderAmountSetting,
          max_powder_amount_setting: this.maxPowderAmountSetting,
        };

        const response = await axios.post("/api/v1/fp/computepowderamountcalibrationstatistic/", body);
        this.original_powder_throughput_statistics = response.data;
        this.expected_powder_per_minute = this.original_powder_throughput_statistics.mean_powder_throughput;
        this.min_powder_throughput = this.original_powder_throughput_statistics.min_powder_throughput;

        await this.saveFormProgress();
      } catch (error) {
        console.error(error);
      }
    },
    async computePowderAmountParameterResults() {
      if (this.emptyBenchmarkPowderAmounts || this.emptyPowderOutputMeasurements) {
        return;
      }
      try {
        let body = {
          time_interval: this.timeInterval,
          measures_list: this.generateMeasurementList(this.powderoutput_measurements),
          powder_per_minute: this.expected_powder_per_minute,
          cumulative_powderoutput_measurements: true,
          min_powder_amount_setting: this.minPowderAmountSetting,
          max_powder_amount_setting: this.maxPowderAmountSetting,
        };

        let response = await axios.post("/api/v1/fp/computepowderamountsettingsfromthroughput/", body);
        this.powder_amount_parameters = response.data.powder_amount_params;
        this.is_compliant_with_target_throughput_per_gun = response.data.is_compliant_with_target_throughput_per_gun;
        this.diagnosis_values_per_gun = response.data.diagnosis_values_per_gun;
        this.powder_amount_parameters = this.roundPowderAmountParameters(this.powder_amount_parameters);

        if (this.expected_powder_per_minute != response.data.powder_per_minute) {
          console.log(
            `Expected powder per minute was adjusted, from ${this.expected_powder_per_minute} to ${response.data.powder_per_minute}`,
          );
          this.expected_powder_per_minute = response.data.powder_per_minute;
        }
      } catch (error) {
        console.error(error);
      }
    },
    autoFillPowderOutputMeasurements(gun_index, setting_index) {
      if (gun_index !== 0) {
        return;
      }
      const inputValue = this.powderoutput_measurements[gun_index].gun_measurements[setting_index].setting;
      if (!this.PowderAmountSettingInputRangeCheck(inputValue, gun_index)) {
        return;
      }
      const emptyInputValue = inputValue === "" || inputValue === null;

      const isColumnEmpty = this.powderoutput_measurements
        .slice(1)
        .every(
          gun =>
            gun.gun_measurements[setting_index].setting === "" || gun.gun_measurements[setting_index].setting === null,
        );

      if (!emptyInputValue && isColumnEmpty) {
        this.powderoutput_measurements.forEach(gun => {
          gun.gun_measurements[setting_index].setting = inputValue;
        });
        return;
      }

      if (emptyInputValue && !isColumnEmpty) {
        const allValuesAreTheSame = this.powderoutput_measurements
          .slice(1)
          .every(
            gun =>
              gun.gun_measurements[setting_index].setting ===
              this.powderoutput_measurements[gun_index + 1].gun_measurements[setting_index].setting,
          );
        if (allValuesAreTheSame) {
          this.powderoutput_measurements.forEach(gun => {
            gun.gun_measurements[setting_index].setting = "";
          });
        }
      }
    },
    async getGunEqualizationData() {
      try {
        let response = await axios.get("/api/v1/blueprint/gunsequalization/" + this.visitId);

        if (response.data == null || response.data == undefined || response.status !== 200) {
          return;
        }

        this.minPowderAmountSetting = response.data.min_powder_amount_setting;
        this.maxPowderAmountSetting = response.data.max_powder_amount_setting;

        if (response.data.time_interval !== null) {
          this.timeInterval = response.data.time_interval;
        }

        if (response.data.powder_output_measurements !== null) {
          this.powderoutput_measurements = response.data.powder_output_measurements;
        }
        if (response.data.thickness_measurements !== null) {
          this.thickness_measurements = response.data.thickness_measurements;
          this.thickness_measurements = this.checkLastRow(this.thickness_measurements);
        }

        this.benchmark_stage_data = JSON.parse(JSON.stringify(this.benchmark_stage_data));

        if (
          response.data.powder_output_measurements !== null &&
          !this.isEmptyPowderOutputMeasurements(response.data.powder_output_measurements)
        ) {
          await this.showGunsEqualizationGraph();
        }
      } catch (error) {
        console.error(error);
      }
      this.$store.state.isLoaded = false;
    },
    async fillWithLatestMeasurements() {
      try {
        this.powderoutput_measurements = await getLatestPowderOutputMeasurementsByLine(this.lineId);
        this.saveFormProgress();
      } catch (error) {
        console.error(error);
        this.$swal({
          title: "Error",
          text: "Failed to fetch latest guns equalization measurements.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    },
    getFormProgressStatus() {
      const PROGRESS_STATUS_PENDING = "Pending";
      const PROGRESS_STATUS_IN_PROGRESS = "In Progress";
      const PROGRESS_STATUS_COMPLETED = "Completed";

      if (
        this.powderoutput_measurements
          .map(gun => gun.gun_measurements)
          .filter(gun_measurment =>
            gun_measurment.some(gun_measurment => gun_measurment.setting !== "" && gun_measurment.weight !== ""),
          ) &&
        this.thickness_measurements.filter(m => m !== null && m !== "") &&
        this.expected_powder_per_minute !== null
      ) {
        return PROGRESS_STATUS_COMPLETED;
      } else if (
        this.powderoutput_measurements
          .map(gun => gun.gun_measurements)
          .filter(gun_measurment =>
            gun_measurment.some(gun_measurment => gun_measurment.setting === "" && gun_measurment.weight === ""),
          ) ||
        this.thickness_measurements.filter(m => m === null && m === "") ||
        this.expected_powder_per_minute === null
      ) {
        return PROGRESS_STATUS_IN_PROGRESS;
      } else {
        return PROGRESS_STATUS_PENDING;
      }
    },
    async saveFormProgress() {
      const formData = {
        powder_output_measurements: this.powderoutput_measurements,
        thickness_measurements: cleanThicknessMeasurementsArray(this.thickness_measurements),
        min_powder_throughput: this.min_powder_throughput,
        min_powder_amount_setting: this.minPowderAmountSetting ? this.minPowderAmountSetting : null,
        max_powder_amount_setting: this.maxPowderAmountSetting ? this.maxPowderAmountSetting : null,
        time_interval: this.timeInterval,
        last_average_powder_throughput_per_gun: this.expected_powder_per_minute,
        progress_status: this.getFormProgressStatus(),
      };

      try {
        await axios.patch("/api/v1/blueprint/gunsequalization/" + this.visitId + "/", formData);
      } catch (error) {
        console.error(error);
      }
    },
    PowderAmountSettingInputRangeCheck(target_value, gun_index) {
      if (
        this.powderoutput_measurements.some(gun =>
          gun.gun_measurements.some(pair => pair.setting !== "" && pair.setting < this.minPowderAmountSetting),
        )
      ) {
        this.$swal({
          title: `Invalid Powder Amount setting: ${target_value}`,
          text: `Powder Output must be greater than the minimum allowed of ${this.minPowderAmountSetting}.`,
          icon: "error",
          confirmButtonText: "OK",
        }).then(() => this.removePowderMeasurementInput(target_value));
        return false;
      } else if (
        this.powderoutput_measurements.some(gun =>
          gun.gun_measurements.some(pair => pair.setting !== "" && pair.setting > this.maxPowderAmountSetting),
        )
      ) {
        this.$swal({
          title: `Invalid Powder Amount setting: ${target_value}`,
          text: `Powder Amount setting must be smaller than the maximum allowed of ${this.maxPowderAmountSetting}.`,
          icon: "error",
          confirmButtonText: "OK",
        }).then(() => this.removePowderMeasurementInput(target_value));
        return false;
      } else if (
        this.powderoutput_measurements[gun_index].gun_measurements.some(
          (pair, index, array) => index > 0 && pair.setting !== "" && pair.setting <= array[index - 1].setting,
        )
      ) {
        this.$swal({
          title: "Invalid Powder Amount setting",
          text: "Each Powder Amount setting must be higher than the previous one.",
          icon: "error",
          confirmButtonText: "OK",
        }).then(() => this.removePowderSettingInput(target_value, gun_index));
        return false;
      }
      return true;
    },
    PowderAmountWeightCheck(target_value, gun_index) {
      if (
        this.powderoutput_measurements[gun_index].gun_measurements.some(
          pair => pair.weight !== "" && pair.weight <= this.powderoutput_measurements[gun_index].empty_bag_weight,
        )
      ) {
        this.$swal({
          title: "Invalid Powder Output Measurement",
          text: "The Powder Output measurement must be higher than the empty bag weight.",
          icon: "error",
          confirmButtonText: "OK",
        }).then(() => this.removePowderWeightInput(target_value, gun_index));
        return;
      } else if (
        this.powderoutput_measurements[gun_index].gun_measurements.some(
          (pair, index, array) => index > 0 && pair.weight !== "" && pair.weight <= array[index - 1].weight,
        )
      ) {
        this.$swal({
          title: "Invalid Powder Output Measurement",
          text: "Each Powder Output Measurement must be higher than the previous one.",
          icon: "error",
          confirmButtonText: "OK",
        }).then(() => this.removePowderWeightInput(target_value, gun_index));
        return;
      }
    },
    removePowderSettingInput(target_value, gun_index) {
      this.powderoutput_measurements[gun_index].gun_measurements.map(pair => {
        if (pair.setting == target_value) {
          pair.setting = "";
        }
      });
    },
    removePowderWeightInput(target_value, gun_index) {
      this.powderoutput_measurements[gun_index].gun_measurements.map(pair => {
        if (pair.weight == target_value) {
          pair.weight = "";
        }
      });
    },
    removePowderMeasurementInput(target_value) {
      this.powderoutput_measurements.map(gun =>
        gun.gun_measurements.map(pair => {
          if (pair.setting == target_value) {
            pair.setting = "";
          }
        }),
      );
    },
    thicknessMeasurementsUpdateChartData() {
      const mu = this.calculateMu(this.thickness_measurements);
      const sigma = this.calculateSigma(this.thickness_measurements, mu);

      this.$store.state.gaussianGunsEqualizationChart.labels = this.generateX(mu, sigma);

      const Xarray = this.$store.state.gaussianGunsEqualizationChart.labels.map(num => parseFloat(num));

      this.$store.state.minTargetThicknessXAxisIndex = Xarray.findIndex(
        num => num > this.benchmark_stage_data.minimum_target_thickness,
      );
      this.$store.state.maxTargetThicknessXAxisIndex = Xarray.findIndex(
        num => num > this.benchmark_stage_data.maximum_target_thickness,
      );

      this.$store.state.gaussianGunsEqualizationChart.datasets[0] = {
        label: "Guns Equalization",
        data: this.generateY(sigma, mu),
      };

      if (this.benchmark_stage_data.thickness_measurements !== null) {
        const benchmarkMu = this.calculateMu(this.benchmark_stage_data.thickness_measurements);
        const benchmarkSigma = this.calculateSigma(this.benchmark_stage_data.thickness_measurements, benchmarkMu);

        this.$store.state.gaussianGunsEqualizationChart.labels = this.generateXforMultipleMuSigma([
          [benchmarkMu, benchmarkSigma],
          [mu, sigma],
        ]);
        const Xarray = this.$store.state.gaussianGunsEqualizationChart.labels.map(num => parseFloat(num));

        this.$store.state.minTargetThicknessXAxisIndex = Xarray.findIndex(
          num => num > this.benchmark_stage_data.minimum_target_thickness,
        );
        this.$store.state.maxTargetThicknessXAxisIndex = Xarray.findIndex(
          num => num > this.benchmark_stage_data.maximum_target_thickness,
        );

        this.$store.state.gaussianGunsEqualizationChart.datasets[0] = {
          label: "Initial Benchmark",
          data: this.generateYwithXvalues(
            benchmarkSigma,
            benchmarkMu,
            this.$store.state.gaussianGunsEqualizationChart.labels,
          ),
        };

        this.$store.state.gaussianGunsEqualizationChart.datasets[1] = {
          label: "Guns Equalization",
          data: this.generateYwithXvalues(sigma, mu, this.$store.state.gaussianGunsEqualizationChart.labels),
        };
      }
    },
    addPair(gunIndex) {
      this.powderoutput_measurements[gunIndex].gun_measurements.push({ setting: "", weight: "" });
    },
    async deletePair(gunIndex) {
      this.powderoutput_measurements[gunIndex].gun_measurements.pop();
      await this.saveFormProgress();
    },
    async showGunsEqualizationGraph() {
      if (!this.isEmptyPowderOutputMeasurements(this.powderoutput_measurements)) {
        this.showPowderThroughputData = true;
        await this.getGunsEqualizationChartDataset();

        await this.getPowderAmountCalibrationStatistic();
        await this.computePowderAmountParameterResults();
        eventBus.emit("draw-gunsequlization-chart");
      }
    },
    showThicknessGraph() {
      this.thicknessMeasurementsUpdateChartData();
      this.statistics_thickness_measurements = JSON.parse(JSON.stringify(this.thickness_measurements));
      eventBus.emit("draw-gaussian-chart");
    },
    async generateLineLayoutImage() {
      try {
        var body = {
          line: this.lineId,
          canvas_width: this.canvas_width,
          canvas_height: this.canvas_height,
        };
        var response = await axios.post("/api/v1/fp/generatelinelayoutimage/", body);
        this.line_layout_image = response.data["layout_image"];
      } catch (error) {
        console.error(error);
      }
    },
    fillLineLayoutCanvas() {
      nextTick(() => {
        var lineLayoutCanvas = document.getElementById("lineLayoutCanvas");
        this.canvas_width = lineLayoutCanvas.width;
        this.canvas_height = lineLayoutCanvas.height;
        this.ctx_line_layout = lineLayoutCanvas.getContext("2d");

        let line_layout_imageData = new ImageData(
          Uint8ClampedArray.from(this.line_layout_image.values()),
          this.canvas_width,
          this.canvas_height,
        );
        this.ctx_line_layout.putImageData(line_layout_imageData, 0, 0);
      });
    },
    PowderAmountSettingAlertCheck() {
      if (
        this.minPowderAmountSetting === null ||
        this.minPowderAmountSetting === "" ||
        this.maxPowderAmountSetting === null ||
        this.maxPowderAmountSetting === ""
      ) {
        return;
      }

      if (this.minPowderAmountSetting >= this.maxPowderAmountSetting) {
        this.$swal({
          title: "Invalid Powder Amount Settings",
          text: "The Min Powder Amount setting must be smaller than the Max Powder Amount setting.",
          icon: "error",
          confirmButtonText: "OK",
        });
        this.minPowderAmountSetting = null;
        this.maxPowderAmountSetting = null;
      } else if (!this.powderAmountWithinRange) {
        this.$swal({
          title: "Invalid Powder Amount Settings",
          text: `The Powder Amount current settings ${this.benchmark_stage_data.gun_settings.map(item => item.powder)}
          must be within the given range of ${this.minPowderAmountSetting} and ${this.maxPowderAmountSetting}.
          Define different Min and Max allowed Powder Amount settings, or change the current Powder Amount settings at Benchmark Stage.`,
          icon: "error",
          confirmButtonText: "OK",
        });
        this.minPowderAmountSetting = null;
        this.maxPowderAmountSetting = null;
      }
    },
  },
};
</script>
<style scoped>
.table-sm th,
.table-sm td {
  padding: 0.3rem;
}

.container-fluid {
  padding-top: 20px;
}
</style>
